import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  padding: 32px 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const Info = styled.p`
  font-size: 14px;
  color: #898b8e;
  font-weight: 400;
`;

export const ScheduleWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
  grid-gap: 10px;
  grid-auto-rows: 30px;
  margin-top: 20px;
`;

interface ScheduleProps {
  active: boolean;
}

const transition = keyframes`
  100% {
    background-color: #004F92;
    color: #FFFFFF;
    border: 0;
  }
`;

export const Schedule = styled.p<ScheduleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 57px; */
  /* height: 27px; */

  border-radius: 16px;
  border: 1px solid #d5d5d6;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-name: ${props => (props.active ? transition : '')};

  font-weight: 500;
  font-size: 14px;
  color: var(--color-gray-500);
  cursor: pointer;
`;
